var _jsxFileName = "/codebuild/output/src454737571/src/bitbucket.org/newyuinc/adc-polaris-web/src/hooks/useAccount.tsx";
import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { differenceInYears, parseISO } from 'date-fns';
import { format } from 'date-fns';
import { RichText } from 'Components/utility';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
const FR_PASSWORD_RULES = ['special', 'uppercase', 'lowercase', 'number', 'spaces'];
const useAccount = () => {
  const showEmailExistsMessage = useCallback(onClickSignIn => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        testID: 'RegisterAccountInfo',
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          testID: "RegisterAccountInfo.accountExists",
          nativeID: "RegisterAccountInfo.accountExists",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30,
            columnNumber: 13
          }
        }, i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.emailExists', {
          appName: i18n.t('Global.appNames.libreView')
        })), /*#__PURE__*/React.createElement(Text, {
          testID: "RegisterAccountInfo.trySignIn",
          nativeID: "RegisterAccountInfo.trySignIn",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38,
            columnNumber: 13
          }
        }, i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.trySignIn'))),
        primaryAction: {
          label: i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.signIn'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onClickSignIn();
          }
        },
        secondaryAction: {
          label: i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.cancel'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        buttonLayout: 'column'
      }
    });
  }, []);
  const showExistingProUserError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.emailExistsProfessional', {
          appName: i18n.t('Global.appNames.libreView')
        })
      }
    });
  }, []);
  const validateEntriesLengthAndDisplayError = items => {
    const messages = [];
    for (const item of items) {
      if (item.count && item.value.length > item.count) {
        messages.push({
          msgKey: item.msgKey,
          count: item.count
        });
      }
    }
    if (messages.length) {
      store.dispatch({
        type: SHOW_MODAL,
        modalProps: {
          details: /*#__PURE__*/React.createElement(Stack, {
            gap: "$4",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 91,
              columnNumber: 13
            }
          }, messages === null || messages === void 0 ? void 0 : messages.map((message, i) => /*#__PURE__*/React.createElement(Text, {
            key: i,
            testID: message.msgKey,
            nativeID: message.msgKey,
            type: "$bodyBase.default",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 93,
              columnNumber: 17
            }
          }, i18n.t(message.msgKey, {
            count: message.count
          }))))
        }
      });
      return false;
    }
    return true;
  };
  const dispatchServerErrorModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Global.modals.errorCommunicatingServer.body'),
        testID: 'ApiErrorModal'
      }
    });
  }, []);
  const dispatchFrancePasswordModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: 4,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          type: "$bodyBase.default",
          nativeID: "CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle",
          testID: "CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129,
            columnNumber: 13
          }
        }, i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle')), /*#__PURE__*/React.createElement(RichText, {
          text: i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.franceValidation'),
          testID: "CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.franceValidation",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 140,
            columnNumber: 13
          }
        })),
        testID: 'Auth'
      }
    });
  }, []);
  const dispatchPasswordValidationModal = useCallback((errorCode, limit) => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: 4,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 158,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          type: "$bodyBase.default",
          nativeID: "CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle",
          testID: "CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle",
          marginBottom: "$1",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 159,
            columnNumber: 13
          }
        }, i18n.t('CreateAccountAccountInfo.modals.accountInfoErrors.differentPasswordTitle')), /*#__PURE__*/React.createElement(Text, {
          key: errorCode,
          color: "$text.100",
          type: "$bodyBase.default",
          nativeID: `CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.${errorCode}`,
          testID: `CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.${errorCode}`,
          marginBottom: 1,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 170,
            columnNumber: 13
          }
        }, i18n.t(`CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.${errorCode}`, {
          count: limit ?? 0
        }))),
        testID: 'Auth'
      }
    });
  }, []);
  const showPasswordValidationError = useCallback((passwordRules, errors, country) => {
    var _passwordRules$find, _passwordRules$find2;
    if (!(errors !== null && errors !== void 0 && errors.length)) {
      dispatchServerErrorModal();
      return;
    }
    const errorCode = errors[0].error;

    // Temporary solution to handle FR-specific password rules
    if (country === 'FR' && FR_PASSWORD_RULES.includes(errorCode)) {
      dispatchFrancePasswordModal();
      return;
    }
    const translationKey = `CreateAccountAccountInfo.modals.accountInfoErrors.securityRules.${errorCode}`;
    if (!i18n.exists(translationKey)) {
      dispatchServerErrorModal();
      return;
    }
    const limit = errorCode === 'max' ? (_passwordRules$find = passwordRules.find(item => item.data.key === errorCode)) === null || _passwordRules$find === void 0 ? void 0 : _passwordRules$find.data.value : (_passwordRules$find2 = passwordRules.find(item => item.type === errorCode)) === null || _passwordRules$find2 === void 0 ? void 0 : _passwordRules$find2.data.limit;
    dispatchPasswordValidationModal(errorCode, limit);
  }, [dispatchFrancePasswordModal, dispatchPasswordValidationModal, dispatchServerErrorModal]);
  const validateIsMinor = useCallback((dateOfBirth, adultAge) => {
    const dob = parseISO(dateOfBirth);
    const age = differenceInYears(new Date(), dob);
    return age < adultAge;
  }, []);
  const validateDOBAndDisplayError = useCallback(dateOfBirth => {
    const today = format(new Date(), 'yyyy-MM-dd');
    if (dateOfBirth > today) {
      store.dispatch({
        type: SHOW_MODAL,
        modalProps: {
          details: i18n.t('CreateAccountPersonalInfo.modals.personalInfoErrors.dobError')
        }
      });
      return false;
    }
    return true;
  }, []);
  const showMinorRestrictionMessage = useCallback(adultAge => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('CreateAccountPersonalInfo.modals.personalInfoErrors.countryInvalidAge', {
          age: adultAge
        })
      }
    });
  }, []);
  return {
    showEmailExistsMessage,
    showExistingProUserError,
    showPasswordValidationError,
    showMinorRestrictionMessage,
    validateEntriesLengthAndDisplayError,
    validateIsMinor,
    validateDOBAndDisplayError
  };
};
export default useAccount;